import { z } from 'zod';

export const searchSchema = z.object({
  // BasicInfoTab - Date range
  ngay_ct1: z.string().optional(), // Start date
  ngay_ct2: z.string().optional(), // End date

  // BasicInfoTab - Document number range
  so_ct1: z.string().optional(), // Start document number
  so_ct2: z.string().optional(), // End document number

  // FilterTab - Filter options
  status: z.string().optional(), // Status filter
  user_id0: z.string().optional() // Filter by user
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const FormSchema = z.object({
  // BasicInfoTab fields - Core voucher information
  ma_ngv: z.string().optional(), // Business operation type
  ma_kh: z.string().optional(), // Customer code
  ma_so_thue: z.string().optional(), // Tax code
  ten_kh_thue: z.string().optional(), // Customer tax name
  dia_chi: z.string().optional(), // Address
  ong_ba: z.string().optional(), // Contact person
  e_mail: z.string().optional(), // Email
  tk: z.string().optional(), // Account
  dien_giai: z.string().optional(), // Description
  so_ct: z.string().optional(), // Document number
  ngay_ct: z.string().optional(), // Document date
  ma_nt: z.string().optional(), // Currency
  ty_gia: z.coerce.number().optional(), // Exchange rate
  status: z.string().optional(), // Status
  transfer_yn: z.boolean().optional(), // Transfer flag

  // OtherTab fields
  ma_gd: z.string().optional(), // Transaction type

  // BottomActionBarV2 fields - Calculated totals (read-only)
  t_tien_nt: z.coerce.number().optional(), // Total amount in foreign currency
  t_tien: z.coerce.number().optional(), // Total amount in VND
  t_thue_nt: z.coerce.number().optional(), // Total tax in foreign currency
  t_thue: z.coerce.number().optional(), // Total tax in VND
  t_tt_nt: z.coerce.number().optional(), // Total payment in foreign currency
  t_tt: z.coerce.number().optional(), // Total payment in VND

  // Additional fields for advance settlement
  qt_tu_yn: z.boolean().optional(), // Auto settlement flag

  // System fields
  unit_id: z.string().optional() // Unit ID
});

export type FormSchema = z.infer<typeof FormSchema>;

export const initialFormValues: FormSchema = {
  // BasicInfoTab fields
  ma_ngv: '2', // Default to "Tạm ứng thông thường"
  ma_kh: '',
  ma_so_thue: '',
  ten_kh_thue: '',
  dia_chi: '',
  ong_ba: '',
  e_mail: '',
  tk: '',
  dien_giai: '',
  so_ct: '',
  ngay_ct: new Date().toISOString(),
  ma_nt: '',
  ty_gia: 1,
  status: '5', // Default to "Đã ghi sổ"
  transfer_yn: false,

  // OtherTab fields
  ma_gd: 'TL',

  // BottomActionBarV2 fields - Calculated totals
  t_tien_nt: 0,
  t_tien: 0,
  t_thue_nt: 0,
  t_thue: 0,
  t_tt_nt: 0,
  t_tt: 0,

  // Additional fields
  qt_tu_yn: false,
  unit_id: ''
};
